import { styled } from '@mui/material';

export const TemplateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  overflowY: 'auto',
  width: '100%',
  flexGrow: 1,
}));

export const TemplateBody = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '1rem',
  paddingTop: '4rem',
}));

export const TemplateBodyV3 = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '1rem',
}));

export const TemplateContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '1rem',
  flex: 1,

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-around',
  },

  [theme.breakpoints.up('md')]: {
    padding: '4rem',
  },
}));
